'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Elevation = require('./Elevation');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Elevation).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Elevation/index.js
// module id = 273
// module chunks = 0